import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config/api";

export default function ForgotPassword() {
  const [login, setLogin] = useState("");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const returnurl = window.location.origin + "/forgot-password";

  const validate = () => {
    if (!login.trim()) {
      setError("Please enter your registered email address.");
      return false;
    }

    if (!/^\S+@\S+\.\S+$/.test(login.trim())) {
      setError("Enter a valid email address.");
      return false;
    }

    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");

    if (!validate()) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/forgot_password.php`,
        { login: login, returnurl: returnurl },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setSuccessMsg(response.data.message);
        setLogin("");   // reset input
        setError("");
      } else {
        setError(response.data.message || "Request failed. Please try again.");
      }
    } catch (err) {
      console.error("Forgot password error:", err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="gray-simple">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6 col-md-8 pt-2">
            <div className="card rounded-4 shadow-sm">
              <div className="card-body p-4">

                {/* Title */}
                <h3
                  className="fw-bold text-center mb-2"
                  style={{ color: "rgb(23, 111, 176)" }}
                >
                  Forgot Your Password?
                </h3>

                <p className="text-center text-muted mb-4">
                  Enter your registered email address to reset your password.
                </p>
 

                {successMsg && (
                  <div className="alert alert-success text-center py-2">
                    {successMsg}
                  </div>
                )}

                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-4">
                    <label className="fw-medium fs-6 text-dark">
                      Email <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      className={`form-control ${
                        error ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your email address"
                      value={login}
                      onChange={(e) => setLogin(e.target.value)}
                    />

                    {/* Inline error (optional extra polish) */}
                    {error && (
                      <div className="invalid-feedback d-block">
                        {error}
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Reset Password"}
                  </button>

                  <p className="text-center mt-4 mb-0">
                    <Link
                      to="/login"
                      className="text-decoration-none fw-medium"
                    >
                      Back to Login
                    </Link>
                  </p>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}